import { useState } from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'
import {
  CustomCategoryForSelectFragment,
  TransactionDetailFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { JournalEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab'

import { DefaultDetails } from './DefaultDetails'
import ProviderInformation from './ProviderInformation'
import { CardPaymentDetails } from './SubtypesDetails/CardPaymentDetails'
import { Categorization } from './SubtypesDetails/Categorization'
import { DisputeDetails } from './SubtypesDetails/DisputeDetails'
import { ExpenseDetails } from './SubtypesDetails/ExpenseDetails'
import { SoftwarePaymentDetails } from './SubtypesDetails/SoftwarePaymentDetails'

const TABS = {
  BASIC_INFORMATION: 'basic-information',
  ACCOUNTING: 'accounting',
}

export interface TransactionDetailComponentProps {
  transaction: TransactionDetailFragment
  currentCategory: CustomCategoryForSelectFragment | null | undefined
  canCategorizeTransaction: boolean
  canManageJournalEntries: boolean
  onChangeCategory: (newCategory?: CustomCategoryForSelectFragment | null) => void
}

export const TransactionDetailComponent = ({
  transaction,
  currentCategory,
  onChangeCategory,
  canCategorizeTransaction,
  canManageJournalEntries,
}: TransactionDetailComponentProps) => {
  const [tab, setTab] = useState(TABS.BASIC_INFORMATION)
  const legalEntity = transaction.bankAccount.account.legalEntity
  const cardPayment =
    transaction.cardPayment || transaction.dispute?.disputedTransaction?.cardPayment

  const tabs = [
    {
      tabId: TABS.BASIC_INFORMATION,
      label: i18n.t('banking.transactions.detail.tabs.basic_information'),
    },
    canManageJournalEntries &&
      transaction.journalEntry &&
      legalEntity && {
        tabId: TABS.ACCOUNTING,
        label: i18n.t('banking.transactions.detail.tabs.accounting'),
      },
  ].filter(Boolean)
  return (
    <Box width="full" gap="s32" paddingBottom="s32">
      <Tabs tabsAlign="flexStart" onTabClicked={(tabId: string) => setTab(tabId)} currentId={tab}>
        {tabs.map(({ tabId, label }) => (
          <Tabs.Tab key={tabId} id={tabId} label={label}>
            {tabId === TABS.BASIC_INFORMATION && (
              <Box width="full" paddingTop="s16" gap="s32">
                <DefaultDetails {...transaction} />
                {!!cardPayment && <CardPaymentDetails {...cardPayment} />}
                {cardPayment?.expense && <ExpenseDetails {...cardPayment} />}
                {cardPayment?.softwarePayment && <SoftwarePaymentDetails {...cardPayment} />}
                {canCategorizeTransaction && (
                  <Categorization
                    currentCategory={currentCategory}
                    onChangeCategory={onChangeCategory}
                  />
                )}
                {transaction.dispute && <DisputeDetails {...transaction} />}
                {transaction.type === 'topup' &&
                  !!transaction.bankAccount.account.onboarding?.provider && (
                    <ProviderInformation
                      provider={transaction.bankAccount.account.onboarding?.provider}
                    />
                  )}
              </Box>
            )}
            {legalEntity && transaction.journalEntry && tabId === TABS.ACCOUNTING && (
              <Box paddingTop={'s16'}>
                <JournalEntryTab
                  journalEntry={transaction.journalEntry}
                  legalEntity={transaction.bankAccount.account.legalEntity}
                  currency={transaction.currency}
                />
              </Box>
            )}
          </Tabs.Tab>
        ))}
      </Tabs>
    </Box>
  )
}
